export const fr = {
  companyActivityCard: {
    title: "Activité de l'entreprise",
    emptyState:
      "Il semble qu'il n'y ait pas d'activité récente de l'entreprise",
  },
}
